import {Alert, Linking, StyleProp, TextStyle} from 'react-native';
import React, {useCallback} from 'react';

import {CustomText} from '@buncha/components/core/text';

interface HyperLinkProps {
  children: React.ReactNode;
  textStyle: StyleProp<TextStyle>;
  linkStyle: StyleProp<TextStyle>;
}

interface LinkProps {
  children: React.ReactNode;
  textStyle: StyleProp<TextStyle>;
  url: string;
}

const Link = (props: LinkProps) => {
  const {url} = props;
  const openUrl = useCallback(async () => {
    const supported = await Linking.canOpenURL(url);
    if (!supported) Alert.alert("Can't handle url: " + url);
    else Linking.openURL(url);
  }, [url]);

  return (
    <CustomText style={props.textStyle} onPress={openUrl}>
      {props.children}
    </CustomText>
  );
};

const Hyperlink = (props: HyperLinkProps) => {
  if (typeof props.children === 'string') {
    const words = props.children.split(/\s/);

    const contents = words.map(function (word: string, i: number) {
      const separator = i < words.length - 1 ? ' ' : '';

      if (word.match(/^https?\:\//))
        return (
          <Link
            textStyle={[props.textStyle, props.linkStyle]}
            key={`${word}`}
            url={word}>
            {word}
            {separator}
          </Link>
        );

      return word + separator;
    });
    // Return the modified content wrapped in a <Text> component
    return <CustomText style={props.textStyle}>{contents}</CustomText>;
  }
  // The nested content was something else than a plain string
  // Return the original content wrapped in a <Text> component
  return <CustomText style={props.textStyle}>{props.children}</CustomText>;
};

export default React.memo(Hyperlink);
